module.exports = __webpack_public_path__ + "img/VI.2cb64230.png";